<style lang="less" scoped>
.k-navbar {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  background: #F9F9F9;
  height: 0.88rem;
}
.k-navbar dl,
.k-navbar dd,
.k-navbar dt {
  margin: 0;
  padding:0;
}
.k-navbar .hd_uinfo {
  position: absolute;
  top: 50%;
  left: .3rem;
  width: 50%;
  height:  0.56rem;
  margin-top: -0.28rem;
}
.k-navbar .hd_uinfo dd,
.k-navbar .hd_uinfo dt {
  float: left;
}
.k-navbar .hd_uinfo a {
  display: block;
  height:  0.56rem;
}
.k-navbar .hd_logo {
  width:  0.56rem;
  height:  0.56rem;
}
.k-navbar .hd_logo img {
  width:  0.56rem;
  height:  0.56rem;
  border: 1px solid #B35C33;
  border-radius: .06rem;
}
.k-navbar .hd_nick {
  color: #666;
  position: absolute;
  top: 0;
  left:  0.72rem;
  font-size:  0.24rem;
  line-height:  0.56rem;
  vertical-align: middle;
  /* color: #fff; */
}
.k-navbar .hd_nick span {
  float: left;
}
.k-navbar .hd_btns {
  position: absolute;
  top: 50%;
  right: 0;
  height:  0.56rem;
  margin-top:  -0.28rem;
  text-align: center;
}
.k-navbar .hd_btns a {
  display: inline-block;
  border: 1px solid #9B9B9B;
  border-radius: .06rem;
  padding: 0 .20rem;
  height: .56rem;
  line-height: .56rem;
  box-sizing: border-box;
}
.k-navbar .hd_btns a,
.k-navbar .hd_btns a:visited {
  font-size:  0.30rem;
}
.k-navbar .hd_btns dd {
  float: left;
  padding-right: .3rem;
}

.k-navbar .hd_btns a,
.k-navbar .hd_btns a:visited {
  color: #9B9B9B;
}
.k-navbar .hd_btn-danger a,
.k-navbar .hd_btn-danger a:visited {
  color: #B62929;
  border-color: #B62929;
}

</style>
<template>
    <div class="k-navbar">
        <div v-if="isValidUser" class="k-navbar__inner">
          <div class="hd_uinfo">
            <a href="javascript:;" class="hd_logo">
              <img :src="myLogo" :alt="myNick">
            </a>
            <a href="javascript:;" class="hd_nick">{{myNick}}</a>
          </div>
          <dl class="hd_btns">
            <dd class="hd_btn-danger r-eid-headMy"><router-link tag="a" to="/match/my">我的战况</router-link></dd>
            <dd class="hd_btn-gray r-eid-headLogout"><a href="javascript:;" x-click="go.logout">退出</a></dd>
          </dl>
        </div>
        <div v-else class="k-navbar__inner">
          <dl class="hd_btns">
            <dd class="hd_btn-danger r-eid-headLoginMob"><a href="javascript:;" x-click="go.login" data-hash="loginMob">验证手机号</a></dd>
            <!-- <dd class="hd_btn-gray"><a href="javascript:;" x-click="go.register">注册</a></dd> -->
          </dl>
        </div>        
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
    export default {
        name: 'k-navbar',
        computed:  mapGetters(['isValidUser', 'myNick', 'myLogo'])
    };
</script>
